export function numberToPercentage(value: number) {
  return new Intl.NumberFormat('default', {
    style: 'percent',
    maximumFractionDigits: 2
  }).format(value / 100);
}
